import { useDispatch } from 'react-redux';
import { Dispatch } from 'react';
import { IBaseActionType } from '../actions';

export type AppAction = IBaseActionType;
export type AppDispatch = Dispatch<AppAction>;

export const useAppDispatch: () => AppDispatch = useDispatch;
